export default {
  en: {
    editPromotion: 'Edit Promotion',
    promotion: 'Promotion',
    code: 'Code',
    detail: 'Detail',
    minNight: 'Min Night',
    maxNight: 'Max Night',
    periodOfStay: 'Period of Stay',
    addPeriod: 'Add Period',
    status: 'Status',
    updatePromotion: 'Save Changes',
    cancel: 'Cancel',
    editPromotionSuccessTitle: 'Success',
    editPromotionSuccessMessage: 'Edit Promotion Success.',
    alertOverlap: 'Period is Overlap',
    applyRoomType: 'Apply Room Type'
  },
  th: {
    editPromotion: 'แก้ไขโปรโมชั่น',
    promotion: 'เรท',
    code: 'รหัส',
    detail: 'รายละเอียด',
    minNight: 'Min Night',
    maxNight: 'Max Night',
    periodOfStay: 'ช่วงเวลาโปรโมชั่น',
    addPeriod: 'เพิ่มช่วงเวลา',
    status: 'สถานะ',
    updatePromotion: 'บันทึก',
    cancel: 'ยกเลิก',
    editPromotionSuccessTitle: 'สำเร็จ',
    editPromotionSuccessMessage: 'แก้ไขโปรโมชั่นสำเร็จ',
    alertOverlap: 'ช่วงเวลาซ้อนทับกัน',
    applyRoomType: 'เลือกใช้ประเภทห้อง'
  }
}
